import { render, staticRenderFns } from "./k-base-form.vue?vue&type=template&id=fc0ec156&scoped=true&"
import script from "./k-base-form.vue?vue&type=script&lang=ts&"
export * from "./k-base-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0ec156",
  null
  
)

export default component.exports